import ApiGatewayFunction from "../../UserConfigs/ApiGatewayFunction.js";

/** Fetches one asset by id. Same Lambda as createAsset/listAssets. */
export async function getAsset(appConfig, { brandId, assetId }, setIsLoading, setApiResponse) {
  const payload = {
    request_type: "studio/create_asset",
    request_sub_type: "get_asset",
    client_id: appConfig.clientId,
    brand_id: brandId,
    asset_id: assetId,
  };

  const response = await ApiGatewayFunction(
    payload,
    appConfig.patternAPI,
    appConfig.support_key,
    appConfig.support_id,
    setIsLoading,
    setApiResponse,
    appConfig.testingState
  );

  const asset = response?.data?.asset;
  if (!asset) {
    throw new Error("Asset not found");
  }
  return asset;
}